// Loader.jsx
import "./Loader.css";
import logo from "../images/logo.png";

export default function Loader() {
  return (
    <div className="loader-container">
      {/* <div className="loader"></div> */}
      <img src={logo} alt="logo" width="700px" />
    </div>
  );
}
